import React, { useEffect, useRef } from 'react'
import Header from '../../landing/Header/Header'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './whitepaper.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Whitepaperbanner = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });


        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        })

            .to(buttonRef.current, {
                rotateY: 360,
                duration: 0.8,
                ease: "power2.inOut",
            });
    }, []);

    useEffect(() => {
        gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
            opacity: 0,
            y: 10,
            duration: 0.6,
            stagger: 0.2,
            ease: "power2.out",
        });
    }, []);


    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://tomi.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Whitepaper", // ✅ Level 2 in JSON
                "item": "https://tomi.com/whitepaper"
            }
        ]
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);


    useEffect(() => {
        document.title = "White-Paper - tomi ";

        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "We aspire to redefine the internet, fostering an environment where freedom of speech, expression, accessibility, and democracy are paramount."
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.setAttribute(
                "content",
                "We aspire to redefine the internet, fostering an environment where freedom of speech, expression, accessibility, and democracy are paramount."
            );
            document.head.appendChild(newMeta);
        }
    }, []);



    return (
        <>
            <>
                <section className='bannermainprnt'>
                    <div className="postionimgwhitepaper">
                        <img className='img-fluid' src="\assets\Whitepaper\whitepaperpostionbanner.png" alt="" />
                    </div>
                    <div className="custom-container">
                        <Header />
                        <div className="bannerprntcnt">
                            <nav aria-label="breadcrumb">
                                <Breadcrumb className="breadcrumbprnt">
                                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                                        Home
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item className="breadvrumbcnt">
                                        Company
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item
                                        className="breadvrumbcntactive"
                                    >
                                        Whitepaper
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </nav>

                            <h1 ref={textRef}>Dive deep into the vision behind TOMI’s decentralized revolution</h1>
                            <a ref={buttonRef} className='whitepaperbannerbtn primerybtn' href="\Tomi_Free_As_In_Speech_Whitepaper_V1.0.pdf" target='_blank'>Download Whitepaper</a>
                        </div>
                    </div>
                </section>
            </>
        </>
    )
}

export default Whitepaperbanner